module.exports = {
  __depends__: [
    require(108),
    require(143)
  ],
  contextPad: [ 'type', require(101) ]
};